import React from 'react';
import classNames from 'classnames';

import css from './IconPhone.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconPhone = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9635 12.1231L12.5839 12.5227C12.5839 12.5227 11.6818 13.4725 9.21927 10.8799C6.75676 8.28736 7.65892 7.33756 7.65892 7.33756L7.89793 7.08593C8.48673 6.46604 8.54223 5.4708 8.02853 4.74425L6.97771 3.25801C6.3419 2.35875 5.1133 2.23996 4.38454 3.0072L3.07654 4.38428C2.71519 4.76471 2.47304 5.25788 2.50241 5.80495C2.57753 7.20455 3.1756 10.2159 6.5128 13.7293C10.0518 17.4552 13.3724 17.6033 14.7302 17.4692C15.1597 17.4269 15.5333 17.1952 15.8343 16.8783L17.0181 15.632C17.8171 14.7908 17.5918 13.3485 16.5694 12.76L14.9774 11.8436C14.306 11.4572 13.4881 11.5707 12.9635 12.1231Z"
        fill="#297DDC"
      />
      <path
        d="M11.0499 1.56673C11.1051 1.22599 11.4272 0.994843 11.7679 1.05001C11.789 1.05404 11.8569 1.06673 11.8924 1.07465C11.9635 1.09048 12.0627 1.11486 12.1864 1.15089C12.4337 1.22292 12.7792 1.34159 13.1939 1.53171C14.0241 1.91233 15.129 2.57817 16.2755 3.72467C17.422 4.87117 18.0878 5.97602 18.4684 6.80625C18.6586 7.22093 18.7772 7.56643 18.8493 7.81375C18.8853 7.93742 18.9097 8.03661 18.9255 8.10772C18.9334 8.14327 18.9392 8.17182 18.9432 8.19291L18.948 8.21891C19.0032 8.55965 18.7742 8.89508 18.4334 8.95025C18.0937 9.00525 17.7736 8.77523 17.717 8.43608C17.7153 8.42698 17.7105 8.40251 17.7054 8.37944C17.6951 8.33329 17.6773 8.2601 17.6491 8.16331C17.5927 7.96969 17.4948 7.68192 17.3322 7.32719C17.0073 6.6186 16.4231 5.64011 15.3916 4.60856C14.36 3.577 13.3815 2.99284 12.673 2.66798C12.3182 2.50535 12.0305 2.40741 11.8368 2.35101C11.74 2.32282 11.6184 2.2949 11.5722 2.28462C11.2331 2.2281 10.9949 1.9065 11.0499 1.56673Z"
        fill="#297DDC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2384 4.44128C11.3333 4.10939 11.6792 3.9172 12.0111 4.01203L11.8394 4.61298C12.0111 4.01203 12.0111 4.01203 12.0111 4.01203L12.0123 4.01238L12.0136 4.01275L12.0163 4.01356L12.0228 4.01549L12.0393 4.02062C12.0519 4.02464 12.0676 4.02987 12.0863 4.03651C12.1237 4.04979 12.1732 4.06868 12.2338 4.09468C12.3552 4.14671 12.5211 4.22706 12.7249 4.34766C13.1328 4.58906 13.6896 4.99004 14.3437 5.64418C14.9979 6.29833 15.3989 6.85515 15.6403 7.26303C15.7608 7.46679 15.8412 7.63268 15.8932 7.75408C15.9192 7.81476 15.9381 7.86422 15.9514 7.90165C15.958 7.92036 15.9633 7.93605 15.9673 7.94861L15.9724 7.9651L15.9744 7.97156L15.9752 7.97434L15.9755 7.97562C15.9755 7.97562 15.9759 7.97682 15.3749 8.14852L15.9759 7.97682C16.0707 8.30871 15.8785 8.65464 15.5466 8.74947C15.2175 8.84349 14.8747 8.65536 14.7764 8.32864L14.7734 8.31966C14.7689 8.30714 14.7597 8.28249 14.7443 8.24648C14.7135 8.17454 14.6575 8.05685 14.5645 7.89969C14.3787 7.58573 14.0431 7.11136 13.4598 6.52807C12.8766 5.94477 12.4022 5.60918 12.0882 5.42338C11.9311 5.33036 11.8134 5.27445 11.7414 5.24361C11.7054 5.22818 11.6808 5.21899 11.6682 5.21455L11.6593 5.21147C11.3326 5.11323 11.1444 4.77036 11.2384 4.44128Z"
        fill="#297DDC"
      />
    </svg>
  );
};

export default IconPhone;
